export class AutenticacaoRequest {
    token: string;
}

export class AutenticacaoResponse {

    userIdentityId: string;
    accessToken: string;
    tokenType: string;
    refreshToken: string;
    expiresIn: string;
    scope: []

}